module.exports = __webpack_public_path__ + "static/media/02.bab30c87.jpg";